



















































import {Component, Prop, Vue} from 'vue-property-decorator';
import GSCartAmountInput from '../../../components/GSCartAmountInput.vue';
import {CartLine, LineItemPosition} from '../types';

@Component({components: {GSCartAmountInput}})
export default class LineItems extends Vue {
  @Prop() cartLines!: CartLine[];
  @Prop() lineItemPositions!: LineItemPosition[];
  @Prop() errors?: any;

  removeCartLine(cartLine: CartLine) {
    this.$emit('remove-cart-line', cartLine)
  }

  updateCart(lineItemId: number, variantId: number, value: number): void {
    this.$emit('amount-updated', lineItemId, variantId, value);
  }

  hasError(lineItemId: number): boolean {
    if (!this.errors) return false;
    const keys = Object.keys(this.errors);
    const position = this.lineItemPositions.findIndex(p => p.id === lineItemId);
    return keys.some(k => k.includes(`.${position}.`));
  }
}
